"use client";

import Link from "next/link";
import { Card, CardContent } from "@/components/ui/card";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import { ChevronRight } from "lucide-react";

const links = {
  Gaming: [
    {
      title: "Events Calendar",
      href: "/events",
      desc: "See what's happening this week",
    },
    { title: "Food Menu", href: "/menu", desc: "See what to eat while you play" },
    { title: "Reservations", href: "/reservations", desc: "Save your spot" },
  ],
  Dining: [
    { title: "Full Menu", href: "/menu", desc: "Explore our Italian cuisine" },
    { title: "Private Events", href: "/private-events", desc: "Host your party here" },
    { title: "Reservations", href: "/reservations", desc: "Book a table" },
  ],
  Events: [
    { title: "Private Events", href: "/private-events", desc: "Venues & packages" },
    { title: "Events Calendar", href: "/events", desc: "Live music, dinners & more" },
    { title: "Menu", href: "/menu", desc: "Catering options" },
  ],
  Music: [
    { title: "Events Schedule", href: "/events", desc: "What's happening this week" },
    { title: "Happy Hour", href: "/menu", desc: "Drinks & specials" },
    { title: "Reservations", href: "/reservations", desc: "Best seats in the house" },
  ],
};

export function RelatedPages({ category }: { category: string }) {
  const related = links[category as keyof typeof links] || links.Dining;

  return (
    <div className="mt-12 border-t border-[var(--roma-parchment-line)] pt-12">
      <div className="mb-6 flex items-center justify-between">
        <h3 className="font-serif text-2xl font-normal text-[var(--foreground)]">
          Explore More
        </h3>
        <span className="text-sm text-[var(--foreground)]/58 md:hidden">Swipe →</span>
      </div>

      <ScrollArea className="-mx-5 px-5 md:mx-0 md:px-0">
        <div className="flex w-max gap-4 pb-4 md:grid md:w-auto md:grid-cols-3 md:pb-0">
          {related.map((item) => (
            <Link key={item.href} href={item.href} className="min-w-[280px] md:min-w-0">
              <Card className="group h-full border-[var(--roma-parchment-line)] bg-[var(--roma-linen)]/35 py-0 shadow-none transition-all hover:border-[var(--roma-terracotta)]/40 hover:bg-[var(--roma-linen)]/55">
                <CardContent className="p-5">
                  <div className="flex h-full flex-col justify-between gap-4">
                    <div>
                      <h4 className="flex items-center gap-1.5 font-serif text-base font-normal text-[var(--foreground)] transition-colors group-hover:text-[var(--roma-terracotta)] md:text-lg">
                        {item.title}
                        <ChevronRight className="h-4 w-4 opacity-50 transition-all group-hover:translate-x-0.5 group-hover:opacity-100" />
                      </h4>
                      <p className="mt-1 text-sm leading-relaxed text-[var(--foreground)]/62">
                        {item.desc}
                      </p>
                    </div>
                    <div className="h-px w-12 bg-[var(--roma-terracotta)]/35 transition-all duration-500 group-hover:w-full group-hover:bg-[var(--roma-terracotta)]/60" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>
        <ScrollBar orientation="horizontal" className="md:hidden" />
      </ScrollArea>
    </div>
  );
}
